import { BRANCH_REQUEST, CREATE_BRANCH, GET_BRANCHES, UPDATE_BRANCH, DELETE_BRANCH, BRANCH_REQUEST_FAILURE } from '../types';

const initialState = {
  branches: [],
  loading: false,
  error: null,
};

const branchReducer = (state = initialState, action) => {
  switch (action.type) {
    case BRANCH_REQUEST: {
      return {
        ...state,
        loading: true,
        error: null
      }
    }
    case GET_BRANCHES: {
      return {
        ...state,
        branches: [...action.payload],
        loading: false,
        error: null
      }
    }
    case CREATE_BRANCH:
      return {
        ...state,
        branches: [action.payload, ...state.branches],
        loading: false,
        error: null
      };
    case UPDATE_BRANCH:
      const branchesData = state.branches.slice(0);
      const uIndex = branchesData.findIndex((data) => data.id === action.payload.id);
      branchesData.splice(uIndex, 1, { ...action.payload.data });
      return {
        ...state,
        branches: [ ...branchesData ],
        loading: false,
        error: null
      };
    case DELETE_BRANCH:
      const branches = state.branches?.slice(0);
      const index = branches.findIndex((data) => data.id === action.id);
      if (index > -1) {
        branches.splice(index, 1);
      }
      return {
        ...state,
        branches: [...branches],
        loading: false,
        error: null
      }
    case BRANCH_REQUEST_FAILURE: {
      return {
        ...state,
        loading: false,
        error: action.error
      }
    }
    default:
      return state;
  }
};

export default branchReducer;
